import React from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import { translate } from 'react-i18next';

import { trackAppDownload } from '../utils/analytics';
import Header from '../containers/PublicRouteHeader';
import Footer from '../containers/PublicRouteFooter';

import '../css/androidDownload.css';

const AndroidInstallGuidePage = ({ t }) => (
  <React.Fragment>
    <Helmet>
      <title>{t('androidInstall.pageTitle')}</title>
      <link
        rel="canonical"
        href={`${process.env.REACT_APP_base_url}/android-install-guide`}
      />
    </Helmet>
    <Header />
    <div className="androidDownloadPage">
      <div className="androidDownloadContainer androidInstallGuide">
        <Link to="/android-download" className="androidInstallGuideBack">
          &larr; {t('androidInstall.backLink')}
        </Link>

        <h1 className="androidDownloadTitle">
          {t('androidInstall.pageTitle')}
        </h1>

        <div className="androidDownloadNotice">
          <p dangerouslySetInnerHTML={{ __html: t('androidInstall.notice') }} />
        </div>

        <div className="androidInstallSteps">
          <h2>{t('androidInstall.stepsTitle')}</h2>
          <ol>
            <li>
              <strong>{t('androidInstall.step1Title')}</strong>
              <br />
              <span
                dangerouslySetInnerHTML={{ __html: t('androidInstall.step1') }}
              />
            </li>
            <li>
              <strong>{t('androidInstall.step2Title')}</strong>
              <br />
              <span
                dangerouslySetInnerHTML={{ __html: t('androidInstall.step2') }}
              />
            </li>
            <li>
              <strong>{t('androidInstall.step3Title')}</strong>
              <br />
              <span
                dangerouslySetInnerHTML={{ __html: t('androidInstall.step3') }}
              />
            </li>
            <li>
              <strong>{t('androidInstall.step4Title')}</strong>
              <br />
              <span
                dangerouslySetInnerHTML={{ __html: t('androidInstall.step4') }}
              />
            </li>
            <li>
              <strong>{t('androidInstall.step5Title')}</strong>
              <br />
              <span
                dangerouslySetInnerHTML={{ __html: t('androidInstall.step5') }}
              />
            </li>
            <li>
              <strong>{t('androidInstall.step6Title')}</strong>
              <br />
              <span
                dangerouslySetInnerHTML={{ __html: t('androidInstall.step6') }}
              />
            </li>
            <li>
              <strong>{t('androidInstall.step7Title')}</strong>
              <br />
              <span
                dangerouslySetInnerHTML={{ __html: t('androidInstall.step7') }}
              />
            </li>
          </ol>

          <div className="androidInstallNote">
            <strong>Note:</strong>{' '}
            <span
              dangerouslySetInnerHTML={{ __html: t('androidInstall.note') }}
            />
          </div>
        </div>

        <Link
          to="/android-download"
          className="androidDownloadBtn androidDownloadBtnText"
          onClick={() => trackAppDownload('android_install_guide', 'android')}
        >
          {t('androidInstall.downloadBtn')}
        </Link>
      </div>
    </div>
    <Footer />
  </React.Fragment>
);

export default translate()(AndroidInstallGuidePage);
